import { ConnectedRouter } from "connected-react-router";
import firebase from "firebase/app";
import * as React from "react";
import "react-datepicker/dist/react-datepicker.css";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fireBaseConfig } from "../config/config";
import Layout from "./container/layout_container";
import ErrorBoundary from "./error_boundary";
import history from "./history";
import "./index.css";
import { unregister } from "./registerServiceWorker";
import Routing from "./routing";
import ScrollToTop from "./scroll_to_top";
import createAppStore from "./store/app_store";

firebase.initializeApp({
  apiKey: fireBaseConfig.apiKey,
  authDomain: fireBaseConfig.authDomain,
  databaseURL: fireBaseConfig.databaseURL,
  projectId: fireBaseConfig.projectId,
  storageBucket: fireBaseConfig.storageBucket,
  messagingSenderId: fireBaseConfig.messagingSender_Id,
});

ReactDOM.render(
  <Provider store={createAppStore()}>
    <ConnectedRouter history={history}>
      <Layout>
        <ErrorBoundary>
          <ScrollToTop>
            <Routing />
          </ScrollToTop>
        </ErrorBoundary>
      </Layout>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root") as HTMLElement
);

declare global {
  interface Window {
    gtag?: (key: string, trackingId: string, params: any) => void;
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/presentation/index.tsx